export default "__VITE_ASSET__DQKWtU61__"